import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class PromoCodeDataProvider {
	constructor(private http: HttpClient) {}

	getAllPromoCodes(data): Observable<any> {
		const {
			perPage,
			page,
			pageOrder: { predicate, reverse },
			search
		} = data;
		const url = '/admin/rest/campaign/all';
		let params = new HttpParams();
		params = params.append('perPage', perPage);
		params = params.append('page', page);
		params = params.append('predicate', predicate);
		params = params.append('reverse', reverse);
		params = params.append('search', search);
		return this.http.get(url, { params });
	}

	getPromoCode(id: number): Observable<any> {
		const url = `/admin/rest/campaign/${id}`;
		return this.http.get(url);
	}

	updatePromoCode(code): Observable<any> {
		const url = '/admin/rest/campaign';
		return this.http.put(url, code);
	}

	createPromoCode(code): Observable<any> {
		const url = '/admin/rest/campaign';
		return this.http.post(url, code);
	}

	applyPromoCode(code: string): Observable<any> {
		const url = '/api/basic/user/promocode';
		const params = new HttpParams().set('code', code);
		return this.http.post(url, {}, { params });
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/services/subscription/promo-code.data.service.ts